/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslationService } from '@gh/core-mls';
import { MessageDialogBaseComponent } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-message-dialog',
  templateUrl: 'message-dialog.component.html',
  styleUrls: ['message-dialog.component.scss'],
})
export class MessageDialogComponent extends MessageDialogBaseComponent {

  constructor(translationService: TranslationService,
              dialogRef: MatDialogRef<MessageDialogBaseComponent>,
              elementRef: ElementRef,
              renderer: Renderer2) {
    super(translationService, dialogRef, elementRef, renderer);
  }
}
